export const FETCH_INOVICE_MONTHS_REQUEST = 'FETCH_INOVICE_MONTHS_REQUEST'
export const FETCH_INOVICE_MONTHS_SUCCESS = 'FETCH_INOVICE_MONTHS_SUCCESS'
export const FETCH_INOVICE_MONTHS_FAILED = 'FETCH_INOVICE_MONTHS_FAILED'
export const FETCH_INVOICE_ANNUAL_SUMMARY_REQUEST = 'FETCH_INVOICE_ANNUAL_SUMMARY_REQUEST'
export const FETCH_INVOICE_ANNUAL_SUMMARY_SUCCESS = 'FETCH_INVOICE_ANNUAL_SUMMARY_SUCCESS'
export const FETCH_INVOICE_ANNUAL_SUMMARY_FAILED = 'FETCH_INVOICE_ANNUAL_SUMMARY_FAILED'
export const DOWNLOAD_INVOICE_PDF_REQUEST = 'DOWNLOAD_INVOICE_PDF_REQUEST'
export const DOWNLOAD_INVOICE_PDF_SUCCESS = 'DOWNLOAD_INVOICE_PDF_SUCCESS'
export const DOWNLOAD_INVOICE_PDF_FAILED = 'DOWNLOAD_INVOICE_PDF_FAILED'
export const FETCH_SELECTED_YEAR = 'FETCH_SELECTED_YEAR'
